import * as httpHelper from 'service/api/httpHelper.js';//网络助手
import storageUtils from 'utils/js/storageUtils.js';//
import store from '@/store/index.js'
import { httpUrl } from 'service/api/httpUrl.js'
import { isArray,isArrayEmpty} from 'utils/js/mixin.js'
// import menuConfig from "config/me_menu.config.js";

/**
 * 获取用户信息
 * 
 */
export function getTokenUser() {
  return new Promise((resolve, reject) => {
    httpHelper.get("getTokenUser",{}).then((res)=>{
      if(res.data){
        storageUtils.saveUserInfo(res.data);
        store.state.user.userInfo=res.data;
        resolve(res);
      }else{
        storageUtils.clear();
        store.state.user.userInfo={};
        window.location.href=httpUrl["clooudLogin"];
        reject(res);
      }
    }).catch((earr)=>{
        storageUtils.clear();
        store.state.user.userInfo={};
        window.location.href=httpUrl["clooudLogin"];
        console.log(earr);
        reject(earr);
    });
  })
}

/**
 * 权限接口
 */
export function getTeacherRole() {
  return new Promise((resolve, reject) => {
    httpHelper.get("getTeacherRole",{}).then((res)=>{
      if(res.data){
        store.state.user.teacherRole=res.data;
      }else{
        store.state.user.teacherRole={};
      }
      resolve(res);
    }).catch((earr)=>{
        store.state.user.teacherRole={};
        console.log(earr);
        reject(earr);
    });
  })
}

/**
 *获取当前菜单children递归菜单路径
 */
function userMenus_2(list){
  if(isArray(list)){
    for (let index = 0; index < list.length; index++) {
      if(list[index].routeUrl){
        store.state.app.menuPathList.push(list[index].routeUrl);
      }
      if(!isArrayEmpty(list[index].children)){
        userMenus_2(list[index].children);
      }
    }
  }
}

/**
 *获取当前菜单children递归
 */
function userMenus_(list,num){
  let result=[];
  if(isArray(list)){
    for (let index = 0; index < list.length; index++) {
      if(list[index].routeUrl){
        store.state.app.menuPathList.push(list[index].routeUrl);
        if(!isArrayEmpty(list[index].children)){
          userMenus_2(list[index].children);
        }
        if(num!=0){
          result.push(list[index]);
        }
      }else if(!isArrayEmpty(list[index].children)){
        list[index].children=userMenus_(list[index].children,num+1);
      }
      // if(!isArrayEmpty(list[index].children)){
      //   list[index].children=userMenus_(list[index].children,num+1);
      // }else{
      //   if(list[index].routeUrl){
      //     store.state.app.menuPathList.push(list[index].routeUrl);
      //     if(num!=0){
      //       result.push(list[index]);
      //     }
      //   }
      // }
      //
      if(num==0&&(!isArrayEmpty(list[index].children)||list[index].routeUrl)){
        result.push(list[index]);
      }
    }
  }
  return result;
}

/**
 *获取当前菜单
 */
export function getMenus(params){
  // return httpHelper.get('getMenus',params);
  return new Promise((resolve, reject) => {
    httpHelper.get("getMenus",params).then((res)=>{
      // res.data=menuConfig.menu;
      if(isArray(res.data)){
        // store.state.app.menuPathList=[];
        // store.state.app.menuList=userMenus_(res.data,0);
        store.state.app.menuList=res.data;
        // console.log(store.state.app.menuPathList)
        // console.log(store.state.app.menuList)
        resolve(res);
      }else{
        store.state.app.menuPathList=[];
        store.state.app.menuList=[];
        reject(res);
      }
    }).catch((earr)=>{
        store.state.app.menuPathList=[];
        store.state.app.menuList=[];
        reject(earr);
    });
  })
}